export default class SectionCollapsible {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.section-collapsible'), el => {
			new SectionCollapsible(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.isOpen = false;

		this.buttons = element.querySelectorAll('.section-collapsible__switcher');
		Array.prototype.forEach.call(this.buttons, button => {
			button.addEventListener('click', () => {this.toggle()});
		});
	}

	open() {
		this.element.classList.remove('section-collapsible--close');
		this.element.classList.add('section-collapsible--open');
		this.isOpen = !this.isOpen;
		this.element.addEventListener("animationend", () => {
			this.element.style.maxHeight = this.element.getBoundingClientRect().height + 'px';
		}, false);
	}

	close() {
		this.element.classList.remove('section-collapsible--open');
		this.element.classList.add('section-collapsible--close');
		this.isOpen = !this.isOpen;
	}

	toggle() {
		this[this.isOpen ? 'close' : 'open']();
	}
}
